import { lazyLoad } from '@/lib/LazyLoad';

export const FiltersPage = lazyLoad(
  () => import('./FiltersPage'),
  (module) => module.FiltersPage
);
